import { render, staticRenderFns } from "./generate-invoice.vue?vue&type=template&id=ddd7c1b8"
import script from "./generate-invoice.vue?vue&type=script&lang=js"
export * from "./generate-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports